import React from 'react';
import {
  ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line,
} from 'recharts';
import CustomTooltip from './CustomTooltip';
import '../plots/plots.css';
import { colorForKey } from './colors';


export function SpeciesTrendByLocationChart({ data }) {
  if (!data) return null;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data.rowsForChart} margin={{ top: 8, right: 16, left: 8, bottom: 0 }}>
        <CartesianGrid stroke="#e5e7eb" vertical={false} />
        <XAxis dataKey="label" tickMargin={8} />
        <YAxis tickMargin={8} tickFormatter={(value) => value.toLocaleString()} />
        <Tooltip content={<CustomTooltip />} />
        <Legend verticalAlign="bottom" height={28} />
        {data.locationKeys.map((key,index) => {
          const color = colorForKey(key, index);
          return (
            <Line
              key={key}
              type="monotone"
              dataKey={key}
              stroke={color}
              strokeWidth={2}
              dot={{ r: 3, stroke: color, fill: color }}
              activeDot={{ r: 4, stroke: color, fill: color }}
            />
          );
        })}
      </LineChart>
    </ResponsiveContainer>
  );
}

export function SpeciesTrendByLocationTable({ data }) {
  if (!data) return null;

  // Utility function for formatting numbers with commas
  const formatNumber = (num) =>
    num !== null && num !== undefined ? num.toLocaleString('en-US') : '';

  return (
    <table className="anl-ttc-table anl-table">
      <thead>
        <tr>
          <th className="col-species">Month</th>
          {data.locationKeys.map((loc) => <th key={loc}>{loc}</th>)}
          <th>Total (per Month)</th>
        </tr>
      </thead>
      <tbody>
        {data.rowsForChart.map((row) => (
          <tr key={row.label}>
            <td className="col-species">{row.label}</td>
            {data.locationKeys.map((loc) => (
              <td key={loc} className="col-number">
                {formatNumber(row[loc] ?? 0)}
              </td>
            ))}
            <td className="col-number">
              {formatNumber(data.locationKeys.reduce((s, k) => s + (row[k] || 0), 0))}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="anl-total-row">
          <td>Total (by Location)</td>
          {data.locationKeys.map((loc) => (
            <td key={loc} className="col-number">
              {formatNumber(data.totalsByLocation[loc])}
            </td>
          ))}
          <td className="col-number">
            {formatNumber(data.totalsByMonth.reduce((s, m) => s + m.total, 0))}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}